// extracted by mini-css-extract-plugin
export var root = "EyeAnimated-module--root--ZHNXm";